/**
 * Prestige Luxe — Global JS
 * Scroll reveal + micro-interactions
 */
(function () {
  'use strict';

  // ── Scroll Reveal ──────────────────────────────────────────
  function initScrollReveal() {
    const els = document.querySelectorAll('.prestige-reveal');
    if (!els.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );

    els.forEach((el) => observer.observe(el));
  }

  // ── Auto-add prestige-reveal to section headers ────────────
  function autoReveal() {
    const targets = document.querySelectorAll(
      '.prestige-section-header, .prestige-collection-card, .prestige-product-card, .prestige-why__card, .prestige-testimonials__card, .prestige-brand-story__content, .prestige-brand-story__media'
    );
    targets.forEach((el, i) => {
      el.classList.add('prestige-reveal');
      if (i % 4 === 1) el.classList.add('prestige-reveal--delay-1');
      if (i % 4 === 2) el.classList.add('prestige-reveal--delay-2');
      if (i % 4 === 3) el.classList.add('prestige-reveal--delay-3');
    });
    initScrollReveal();
  }

  // ── Sticky Header Shadow ───────────────────────────────────
  function initHeaderScroll() {
    const headerGroup = document.getElementById('header-group');
    if (!headerGroup) return;
    window.addEventListener('scroll', () => {
      headerGroup.classList.toggle('prestige-scrolled', window.scrollY > 60);
    }, { passive: true });
  }

  // ── Quick Add feedback ─────────────────────────────────────
  function initQuickAddFeedback() {
    document.addEventListener('submit', function (e) {
      const form = e.target;
      if (!form.closest('.prestige-product-card')) return;
      const btn = form.querySelector('.prestige-product-card__quick-add');
      if (!btn) return;
      const originalHTML = btn.innerHTML;
      btn.innerHTML = '<span>Added!</span>';
      btn.style.background = '#4caf50';
      btn.style.color = '#fff';
      setTimeout(() => {
        btn.innerHTML = originalHTML;
        btn.style.background = '';
        btn.style.color = '';
      }, 1800);
    });
  }

  // ── Init ───────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      autoReveal();
      initHeaderScroll();
      initQuickAddFeedback();
    });
  } else {
    autoReveal();
    initHeaderScroll();
    initQuickAddFeedback();
  }
})();
